import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/qa/qaitem/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/qa/qaitem/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/qa/qaitem/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/qa/qaitem/submit',
    method: 'post',
    data: row
  })
}

